const CANCELLABLE_STATUSES = new Set<ScheduleEventStatus>([
  "RESERVED",
  "ANNOUNCED",
  "CONFIRMED",
  "COMPLETED",
])
const CONFIRMABLE_STATUSES = new Set<ScheduleEventStatus>(["RESERVED", "ANNOUNCED"])

const normalizeScheduleValue = (value: string | null | undefined) =>
  (value || "").trim().toUpperCase()

export const isCancelableAppointment = (
  event: ScheduleEvent | null | undefined,
): event is ScheduleEvent =>
  Boolean(
    event?.id &&
    normalizeScheduleValue(event.event_type) === "APPOINTMENT" &&
    CANCELLABLE_STATUSES.has(normalizeScheduleValue(event.status) as ScheduleEventStatus),
  )

export const isConfirmableAppointment = (
  event: ScheduleEvent | null | undefined,
): event is ScheduleEvent =>
  Boolean(
    event?.id &&
    normalizeScheduleValue(event.event_type) === "APPOINTMENT" &&
    CONFIRMABLE_STATUSES.has(normalizeScheduleValue(event.status) as ScheduleEventStatus),
  )
